@import './ionic-selectable.component';
@import './ionic-selectable.ios.vars.component';

// iOS ionic-sectable
// --------------------------------------------------

:host {
  --padding-top: #{$ionic-selectable-ios-padding-top};
  --padding-end: #{$ionic-selectable-ios-padding-end};
  --padding-bottom: #{$ionic-selectable-ios-padding-bottom};
  --padding-start: #{$ionic-selectable-ios-padding-start};
}

:host(.item-label-stacked),
:host(.item-label-floating) {
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 0;
}

.ionic-selectable-icon {
  width: 12px;
  height: 18px;
}
